import { ConfigurationItemEditor } from '@client/components/_core/configuration/ConfigurationItemEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { SuppliersTabs } from './SuppliersTabs';

export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/definitions')({
    staticData: {
        metadata: {
            title: 'Supplier definitions',
        },
        ui: {
            title: 'Suppliers configuration',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <SuppliersTabs active="definitions" />
            <ConfigurationItemEditor
                title="Supplier categories"
                settingToEdit="SUPPLIER_CATEGORIES"
                description="Rename, add or remove a category."
                editor={{ height: '150px' }}
            />
        </PageController>
    );
}
